var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCommentShow)?_c('div',{staticClass:"icon icon_primary icon-message",attrs:{"title":_vm.$t('src/components/training/commenticon.3326')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }